
  import { Component, Vue } from 'vue-property-decorator';
  import EternaPage from '@/components/PageLayout/EternaPage.vue';
  import SidebarPanel from '@/components/Sidebar/SidebarPanel.vue';


  @Component({
    components: {
      EternaPage,
      SidebarPanel,
    },
  })
  export default class GamerGuide extends Vue {

  }
